/* Base translations · Review form items — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): reviewFormItems. */
export const I18N_BASE_REVIEW_FORM_ITEMS = {
  en: {
    reviewFormItems: {
      engagement_letter: {
        content: {
          item_1: "The objective and scope of the review of the financial statements (limited assurance, ISRE 2400 Revised).",
          item_2: "The responsibilities of the practitioner — to conduct the review and express a limited-assurance conclusion.",
          item_3: "The responsibilities of management for the financial statements and for making information available.",
          item_4: "Identification of the applicable financial-reporting framework.",
          item_5: "Reference to the expected form and content of the review report (limited-assurance conclusion, not an audit opinion), and a statement that circumstances may require the report to differ from its expected form and content.",
        },
      },
    },
  },
  ar: {
    reviewFormItems: {
      engagement_letter: {
        content: {
          item_1: "الغرض من الفحص ونطاقه للقوائم المالية (تأكيد محدود، \u2066ISRE 2400\u2069 المُنقّح).",
          item_2: "مسؤوليات الممارس — إجراء الفحص والتعبير عن خلاصة تأكيد محدود.",
          item_3: "مسؤوليات الإدارة عن القوائم المالية وإتاحة المعلومات.",
          item_4: "تحديد إطار التقرير المالي المطبَّق.",
          item_5: "الإشارة إلى الشكل والمحتوى المتوقعين لتقرير الفحص (خلاصة تأكيد محدود، وليس رأي مراجعة)، وبيان أن الظروف قد تستلزم اختلاف التقرير عن شكله ومحتواه المتوقعين.",
        },
      },
    },
  },
};

export default I18N_BASE_REVIEW_FORM_ITEMS;
